import {AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild,} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {Participation} from 'src/app/domain';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {icons} from 'src/app/ui/icons';

type Column = keyof Participation;

@Component({
    selector: 'app-participation-table',
    templateUrl: './participation-table.component.html',
    styleUrls: ['./participation-table.component.css'],
})
export class ParticipationTableComponent implements OnInit, AfterViewInit {
    @Input() participations: Participation[];
    @ViewChild(MatSort) sort: MatSort;
    dataSource = new MatTableDataSource<Participation>();
    displayedColumns: Column[] = ['bidCls', 'licenseCd'];
    labels: Partial<Record<Column, string>> = {
        bidCls: 'N° Lot/Article',
        licenseCd: 'Informations sur agrément',
    };
    icons = icons;
    @Input() ondelete: boolean;

    constructor(
        private confirmDialogService: ConfirmDialogService,
        private dialog: MatDialog,
        private router: Router
    ) {
    }

    get readColumns() {
        return this.displayedColumns;
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {participations} = changes;
        if (participations.currentValue !== participations.previousValue) {
            this.loadDataSource(participations.currentValue);
        }
    }

    loadDataSource(participations: Participation[]) {
        this.dataSource.data = participations;
    }
}
